var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPairingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L26 22",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 26.6671L28.6667 23.3337C30.1333 21.8671 30.1333 19.4671 28.6667 18.0004C27.2 16.5337 24.8 16.5337 23.3333 18.0004L20 21.3337",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 21.333L19.3334 24.6663C17.8667 26.133 17.8667 28.533 19.3334 29.9997C20.8001 31.4663 23.2001 31.4663 24.6667 29.9997L28.0001 26.6663",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairingActive);
export default __webpack_public_path__ + "static/media/pairing-active.50b31671b30d81af86241cfb3d3eb15f.svg";
export { ForwardRef as ReactComponent };